import { useState } from "react";
import { Props_SnippetVideoContent } from "./VideoContent.props";
import { CompileMarkdown } from "../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler";

const convertIframeUrl = (url: string): string => {
  let newUrl = url;

  // Handle YouTube URLs
  if (url.includes("watch?v=")) {
    newUrl = url.replace("watch?v=", "embed/");
  } else if (url.includes("youtu.be")) {
    newUrl = url.replace("youtu.be/", "youtube.com/embed/");
  }

  // Handle Vimeo URLs
  if (url.includes("vimeo.com")) {
    const match = url.match(/vimeo\.com\/(\d+)/);
    if (match) {
      newUrl = `https://player.vimeo.com/video/${match[1]}`;
    }
  }

  // Add autoplay for all URLs if not already present
  if (!newUrl.includes("autoplay=1")) {
    newUrl = `${newUrl}${newUrl.includes("?") ? "&" : "?"}autoplay=1`;
  }

  return newUrl;
};

const Video = (props: Props_SnippetVideoContent) => {
  const { snippetOptions, videoOptions, contentOptions } = props;

  const position = contentOptions?.contentSectionPosition?.value;
  const showTitle = snippetOptions.showTitle?.value === "true";
  const convertedUrl = convertIframeUrl(videoOptions?.videoUrl?.value ?? "");
  const [playing, setPlaying] = useState(false);
  const videoSectionClassName =
    "snippet-video-content__video-section" +
    (playing ? " snippet-video-content__video-section--playing" : "");
  const additionalId = snippetOptions.snippetid?.value
    ? `-${snippetOptions.snippetid?.value}`
    : "";
  const backgroundClassName = snippetOptions.backgroundColor?.value
    ? ` snippet-video-content--${snippetOptions.backgroundColor.value}`
    : "";

  const handlePlay = () => {
    setPlaying(true);
  };

  return (
    <section
      className={"snippet-video-content " + backgroundClassName}
      id={additionalId}
    >
      <div
        className={
          "snippet-video-content__container snippet-video-content__container--" +
          position
        }
      >
        <div className={videoSectionClassName}>
          {!playing && (
            <button
              className="snippet-video-content__play-button play-button"
              aria-label="play"
              onClick={handlePlay}
            ></button>
          )}
          {!playing && videoOptions?.image?.value && (
            <figure className="snippet-video-content__image-container">
              <img
                src={videoOptions?.image?.value}
                alt="video thumbnail"
                className="snippet-video-content__image"
                loading="lazy"
                width="1920"
                height="1080"
              />
            </figure>
          )}
          {playing && (
            <iframe
              width="560"
              height="315"
              src={convertedUrl}
              title="YouTube video player"
              loading="lazy"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              className="snippet-video-content__video"
              allowFullScreen={true}
            ></iframe>
          )}
        </div>
        <div className="snippet-video-content__content-section">
          <div className="snippet-video-content__inner-content-container">
            <h2
              className={
                "snippet-video-content__title" +
                (showTitle ? "" : " accessible-heading")
              }
            >
              {snippetOptions?.heading?.value}
            </h2>
            {contentOptions?.text?.value && (
              <div className="snippet-video-content__text">
                {CompileMarkdown(contentOptions.text.value)}
              </div>
            )}
            {contentOptions?.linkText?.value &&
              contentOptions?.linkUrl?.value && (
                <a
                  className="snippet-video-content__link"
                  href={contentOptions.linkUrl.value}
                  target={
                    contentOptions.openInNewTab?.value === "true"
                      ? "_blank"
                      : "_self"
                  }
                  rel={
                    contentOptions.openInNewTab?.value === "true"
                      ? "noopener noreferrer"
                      : undefined
                  }
                  onClick={() => {
                    if (playing) {
                      setPlaying(false);
                    }
                  }}
                >
                  {contentOptions.linkText.value}
                </a>
              )}{" "}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Video;
